import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionSummary, Box, FormControlLabel } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import InfoIcon from "../../../../../assets/images/icons/InfoIcon";
import BriaCheckbox from "../../../../../components/common/BriaCheckbox/BriaCheckbox";
import BriaInput from "../../../../../components/common/BriaInput/BriaInput";
import BriaSlider from "../../../../../components/common/BriaSlider/BriaSlider";
import BriaTooltip from "../../../../../components/common/BriaTooltip/BriaTooltip";
import { useAppStore } from "../../../../../hooks/useStores";
import InputLayout from "../../../../../layout/InputLayout/InputLayout";
import { tgAdvancedConfig } from "../../../../NewTG/App/Image/Config/TgImageGenerationConfig";
import styles from "../TextToImageConfig.module.scss";
import TextToImageSteps from "./Steps/TextToImageSteps";

const TextToImageAdvanced = () => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.config" });
	const { textToImageStore } = useAppStore();
	const { config, handleConfigChange } = textToImageStore;
	const hideNegativePrompt =
		(!!config.tailored_model_id && config.training_version === "light") ||
		config.model_name?.toLowerCase().includes("fast");
	const maxNumResults =
		(config.tailored_model_id
			? tgAdvancedConfig.max_results
			: textToImageStore.models[config.model]?.max_results) || 4;

	const handleNumResultsChange = (_event: any, numResults: number | number[]) => {
		handleConfigChange("num_results", numResults as number);
	};

	console.log(hideNegativePrompt);
	return (
		<Accordion elevation={0} disableGutters TransitionProps={{ timeout: 200 }} className={styles.advancedAccordion}>
			<AccordionSummary color="initial" expandIcon={<ExpandMore />} className={styles.accordionSummary}>
				{t("advanced")}
			</AccordionSummary>
			<Box className={styles.advanced}>
				<InputLayout
					label={t("negativePrompt.label")}
					labelClassName={styles.inputLabel}
					info={
						hideNegativePrompt || textToImageStore.hideNegativePrompt
							? t("negativePrompt.disabledInfo")
							: t("negativePrompt.info")
					}
				>
					<BriaInput
						value={textToImageStore.config?.negative_prompt}
						onChange={(e) => textToImageStore.handleConfigChange("negative_prompt", e.target.value)}
						multiline
						minRows={4}
						placeholder={
							hideNegativePrompt
								? t("negativePrompt.disabledPlaceholder")
								: t("negativePrompt.placeholder")
						}
						inputProps={{ className: styles.inputBase }}
						disabled={hideNegativePrompt || textToImageStore.hideNegativePrompt}
					/>
				</InputLayout>
				<InputLayout
					label={t("numberOfImages.label")}
					labelClassName={styles.inputLabel}
					info={t("numberOfImages.info")}
				>
					<BriaSlider
						value={config.num_results}
						onChange={handleNumResultsChange}
						step={1}
						min={1}
						max={maxNumResults}
						marks={Array.from({ length: maxNumResults }, (_, index) => ({
							value: index + 1,
							label: `${index + 1}`,
						}))}
					/>
				</InputLayout>
				{!textToImageStore.isTextToVector() && (
					<Box className={styles.refineFacesCheckbox}>
						<FormControlLabel
							control={
								<BriaCheckbox
									checked={textToImageStore.config?.enhance_image}
									onChange={(e) =>
										textToImageStore.handleConfigChange("enhance_image", e.target.checked)
									}
								/>
							}
							label={t("enhanceImage.label")}
						/>
						<BriaTooltip title={t("enhanceImage.info")} className={styles.info} displayOn="click">
							<InfoIcon className={styles.infoIcon} />
						</BriaTooltip>
					</Box>
				)}

				<TextToImageSteps />

				<InputLayout
					label={t("seedNumber.label")}
					labelClassName={styles.inputLabel}
					info={t("seedNumber.info")}
				>
					<BriaInput
						type="number"
						value={config?.seed}
						onChange={(e) =>
							handleConfigChange("seed", e.target.value ? parseFloat(e.target.value) : undefined)
						}
						placeholder={t("seedNumber.placeholder")}
						height="37px"
						inputProps={{ className: styles.inputBase }}
					/>
					<FormControlLabel
						control={
							<BriaCheckbox
								checked={config?.displaySeed}
								onChange={(e) => handleConfigChange("displaySeed", e.target.checked)}
							/>
						}
						label={t("seedNumber.checkbox")}
					/>
				</InputLayout>
			</Box>
		</Accordion>
	);
};

export default observer(TextToImageAdvanced);
